import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

import { ItemValue } from '../ResourceModels/analytics/ItemValue';
import { single, multi, unattended, unattended1, messages } from './data';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({ providedIn: 'root' })

export class AnalyticsService {

  private analyticsUrl = 'api/analitycs';  // URL to web api

  constructor(
    private http: HttpClient
) 
{ }

  /** GET UnattendedCases from the server */
  getUnattendedCases(): Observable<any[]> {
    return of(unattended1);
    // return this.http.get<ItemValue[]>(`${this.analyticsUrl}`)
    //   .pipe(
    //     tap(heroes => this.log('fetched UnattendedCases')),
    //     catchError(this.handleError('getUnattendedCases', []))
    //   );
  }

  /** GET NPSStatisticsByClinic from the server */
  getNPSStatisticsByClinic(): Observable<any> {    
    return this.http.get(`${this.analyticsUrl}/NPSStatisticsByClinic`).pipe(
      tap(_ => this.log('fetched NPSStatisticsByClinic')),
      catchError(this.handleError('getNPSStatisticsByClinic', []))
    );
  }   

  
 /** GET NumberMessagesSended from the server */
  getNumberMessagesSended(): Observable<any> {    

    return of(messages);
    // return this.http.get(`${this.analyticsUrl}/NumberMessagesSended`).pipe(
    //   tap(_ => this.log('fetched NumberMessagesSended')),
    //   catchError(this.handleError('getNumberMessagesSended', []))
    // );
  }   

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  /** Log a HeroService message with the MessageService */
  private log(message: string) {
    //this.messageService.add(`HeroService: ${message}`);
  }
}
